import { render, staticRenderFns } from "./studentNoLost.vue?vue&type=template&id=b295aeb8"
import script from "./studentNoLost.vue?vue&type=script&lang=js"
export * from "./studentNoLost.vue?vue&type=script&lang=js"
import style0 from "./studentNoLost.vue?vue&type=style&index=0&id=b295aeb8&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports